import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { SingleSelectFilterPicker } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { DateFilterPickerPresets } from './DateFilterPicker.types';
export function DateFilterPicker(props) {
    const { value, onChange } = props;
    const { t: invoiceTexts } = useLocaleKeys('invoice');
    const datesPresets = useMemo(()=>[
            {
                label: invoiceTexts.datePresetLabels.allTime(),
                value: DateFilterPickerPresets.AllTime
            },
            {
                label: invoiceTexts.datePresetLabels.today(),
                value: DateFilterPickerPresets.Today
            },
            {
                label: invoiceTexts.datePresetLabels.thisWeek(),
                value: DateFilterPickerPresets.ThisWeek
            },
            {
                label: invoiceTexts.datePresetLabels.thisMonth(),
                value: DateFilterPickerPresets.ThisMonth
            },
            {
                label: invoiceTexts.datePresetLabels.previousMonth(),
                value: DateFilterPickerPresets.PreviousMonth
            },
            {
                label: invoiceTexts.datePresetLabels.lastThreeMonths(),
                value: DateFilterPickerPresets.LastThreeMonths
            }
        ], []);
    return /*#__PURE__*/ _jsx(SingleSelectFilterPicker, {
        bi: {
            name: 'invoice_date_filter'
        },
        value: value,
        testId: 'date-filter-picker',
        options: datesPresets,
        label: invoiceTexts.filterLabels.date(),
        onChange: (option)=>option ? onChange(option.value) : null
    });
}
